var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_753",
    "data-name": "Subtraction 753",
    d: "M15,30A15,15,0,0,1,4.394,4.394,15,15,0,1,1,25.607,25.607,14.9,14.9,0,0,1,15,30Zm-.02-22.063a3.516,3.516,0,0,0-3.212,3.749A3.872,3.872,0,0,0,13.476,15l-1.178.545L9.164,17a.8.8,0,0,0-.454.771v3.452a.808.808,0,0,0,.7.841H20.563a.8.8,0,0,0,.727-.841V17.771A.8.8,0,0,0,20.837,17l-3.021-1.454-1.255-.595a3.9,3.9,0,0,0,1.631-3.264A3.516,3.516,0,0,0,14.981,7.937Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d27f5963de5f9c985b096e840873ebb7.svg";
export { ForwardRef as ReactComponent };